export default __webpack_public_path__ + "static/media/kg254c.b1ea5007.jpg";